export const waitForCheckoutSDK = async (maxAttempts = 20, delayMs = 250): Promise<boolean> => {
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    if ((window as any).Checkout) {
      return true;
    }
    await new Promise((resolve) => setTimeout(resolve, delayMs));
  }
  return false;
};

export const waitForElement = async (selector: string, maxAttempts = 50, delayMs = 100): Promise<void> => {
  let attempt = 0;
  while (attempt < maxAttempts) {
    const element = document.querySelector(selector);
    if (element) {
      return;
    }
    await new Promise((resolve) => setTimeout(resolve, delayMs));
    attempt++;
  }
  throw new Error(`Element "${selector}" not found after ${maxAttempts} attempts.`);
};
